<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" @submit.native.prevent label-width="80px">
            <el-form-item label="关键字：" prop="keyword">
                <el-input v-model.trim="searchForm.keyword" style="width: 250px" maxlength="20"
                          placeholder="请输入关键字(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="dataBox">
            <el-table
                    :data="dataList"
                    v-loading="loading"
                    size="small" height="100%"
                    class="table" border
                    ref="multipleTable"
                    :row-key="'id'"
                    @selection-change="selectionChangeHandle"
                    @sort-change="sortChangeHandle"
            >
                <el-table-column :reserve-selection="true" type="selection" width="50"/>
                <el-table-column prop="modelName" label="模型名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="modelRemark" label="备注" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createByName" label="创建人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateDate" label="最新修改时间" sortable="custom"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="createDate" label="创建时间" sortable="custom"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" min-width="70px" label="操作">
                    <template slot-scope="{row}">
                        <el-button v-if="hasPermission('academic:academic:publicModel:detail')" type="text"
                                   size="small"
                                   @click="addData(1,row)">详情
                        </el-button>
                        <el-button v-if="hasPermission('academic:academic:publicModel:save')" type="text" size="small"
                                   @click="saveData(row)">保存
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <learning-detail ref="learningDetail"></learning-detail>
        <save-data-my ref="saveDataMy" @saveSuccess="saveSuccess"></save-data-my>
    </div>
</template>

<script>

import LearningDetail from "@/views/modules/academic/academic/learningDetail.vue";
import SaveDataMy from "@/views/modules/academic/academic/learningNode/saveDataMy.vue";
import router from "@/router";

export default {
    name: "publicModel",
    components: {SaveDataMy, LearningDetail},
    data() {
        return {
            searchForm: {
                keyword: '',
                orderBy: "",
                current: 1,
                size: 20,
            },
            total: 0,
            loading: false,
            dataList: [],
            dataListSelect: [],
        }
    },

    mounted() {
        this.refreshList()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            this.loading = true
            this.$axios(this.api.academic.knowledgemodelPublicList, this.searchForm).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },
        //排序
        sortChangeHandle(obj) {
            obj.prop = this.getHumpLineName(obj.prop);
            if (obj.order === 'ascending') {
                this.searchForm.orderBy = obj.prop + ' asc'
            } else if (obj.order === 'descending') {
                this.searchForm.orderBy = obj.prop + ' desc'
            } else {
                this.searchForm.orderBy = ''
            }
            this.refreshList(1)
        },
        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.searchForm.orderBy = ''
            this.refreshList(1, 1)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        //num 0新增 1详情 2编辑
        addData(num, row) {
            this.$refs.learningDetail.init(row)
        },

        saveData(row) {
            this.$refs.saveDataMy.init(row)
        },

        saveSuccess(){
            this.$confirm('已保存到【知识模型管理】，是否现在查看？', '保存成功！', {
                confirmButtonText: '去查看',
                cancelButtonText: '关闭',
                type: 'warning'
            }).then(() => {
                this.$router.push({
                  path:'/academic/academic/learningModel',
                  query:{
                      type:Math.random()
                  }
                })
            })
        },
    }
}
</script>

<style scoped>

</style>
